import { render, staticRenderFns } from "./ClientAddresses.vue?vue&type=template&id=ffde697c&scoped=true&"
import script from "./ClientAddresses.vue?vue&type=script&lang=js&"
export * from "./ClientAddresses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffde697c",
  null
  
)

export default component.exports